module.exports = {"content":{},"productInfo":{"code":"{E17765BE-741E-405B-8054-D132C0D63FEF}","name":"ロシア語　初中級","serialHead":"BRWRJ","courseResourceIDs":[{"levelNo":1,"resourceID":"8c7a97835c4350103ee72d5408209f09ba263768"},{"levelNo":2,"resourceID":"63523e51200c0c64f590f14e39f25e852327244b"},{"levelNo":3,"resourceID":"4a15c7c5ede1e6f7cf381dbf3ac7c347bc0a4945"},{"levelNo":4,"resourceID":"08f3fc0ce839ee708272dfae6fd2e3f2082c6fef"},{"levelNo":5,"resourceID":"bd0da1efa7088547139300612f8fe2797f543519"}],"language":"ru-RU","challengeCount":33056},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1